module.exports = __webpack_public_path__ + "static/media/sankey_chart_example.0025c10d.jpg";